import { useState } from "react";
import { safeOpenURL } from "@/shared/lib/utils";

type EventMapProps = {
  address: string;
};

export function EventMap({ address }: EventMapProps) {
  const [hasError, setHasError] = useState(false);

  const apiKey = process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY;
  const query = encodeURIComponent(address);
  const embedUrl = apiKey
    ? `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${query}&zoom=15`
    : `https://maps.google.com/maps?q=${query}&z=15&output=embed`;

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${query}`;

  const handleOpenInMaps = () => {
    safeOpenURL(mapsUrl);
  };

  if (hasError) {
    return (
      <div
        className="border-border bg-muted/50 flex h-[200px] flex-col items-center justify-center rounded-xl border"
        role="img"
        aria-label="Map failed to load"
      >
        <svg
          className="text-muted-foreground h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          />
        </svg>
        <p className="text-muted-foreground mt-2 text-sm">
          Não foi possível carregar o mapa
        </p>
        <button
          onClick={handleOpenInMaps}
          className="bg-primary text-primary-foreground mt-3 flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium"
          aria-label="Abrir no Google Maps"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
          Abrir no Maps
        </button>
      </div>
    );
  }

  return (
    <div
      className="h-[200px] overflow-hidden rounded-xl"
      role="img"
      aria-label={`Mapa mostrando localização: ${address}`}
    >
      <iframe
        src={embedUrl}
        className="h-full w-full border-0"
        style={{ filter: "invert(90%) hue-rotate(180deg)" }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        onError={() => setHasError(true)}
        onLoad={() => {
          // Reset error state when iframe loads successfully
          setHasError(false);
        }}
        title={`Mapa do local: ${address}`}
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      />
    </div>
  );
}
